import React, { useState, useEffect } from 'react';
import { BreadCrumb, Colors } from '@dm/bigfish';
import { useLocation } from 'react-router-dom';

import styled, { css } from 'styled-components';
import Translate from 'lib/Translate';
import SVG from 'react-inlinesvg';
import { IPackagePrice, Category, IOwnerUser, PaymentTypeEnum, PaymentGatewayResponse } from '@dm/types';
import { TailSpin, Oval } from 'react-loader-spinner';

import { RootState, AppDispatch } from 'redux/store';
import Actions from 'redux/Actions';
import Selectors from 'redux/Selectors';
import { connect } from 'react-redux';

import NavActions from 'lib/NavActions';
import config from 'config';
import media from 'lib/Breakpoints';
import Icons from '../../assets/icons';
import PaymentUpload from './WalletTopUpComponents/WalletTopUpUpload';

import MainContainer from '../../components/MainContainer';
import PackagesEmailPromptModal from './PackagesEmailPrompt';

export interface IDropdownProfile {
    p: string;
    onClick?: () => void;
}

interface SubscribePackagesProps {
    setPackagesTopUpPayments(propertyId: string, paymentType: number, amount: number, bankNumber: string, accountName: string, bankName: string, reference: string): void;
    packagesPricingList: IPackagePrice;
    userListUserInfo: IOwnerUser | undefined;
    getUserInfo: () => void;
    isModalOpen: boolean;
    setModalOpen: (state: boolean) => void;
    buyAllPackagesOrNot: boolean;
    buyPackagesSeparately: boolean,
    emailModalOpen: boolean,
    paymentIdData: PaymentGatewayResponse; // PaymentID is name paymentIdData.paymentId because there is another paymentId in line 80 so to differenchiate both payment id
    paymentIdFailed: string;
    packagesPurchaseTopUpAttempt: boolean;
    packagesPurchaseTopUpError: string;
    packagesPurchaseTopUp: PaymentGatewayResponse | null;

}

interface NavParams {
    propertyIndividualId: string;
    AmountTopUp: number;
}

const PackagesWalletTopUp = (props: SubscribePackagesProps): JSX.Element => {
    const { packagesPricingList, setPackagesTopUpPayments, getUserInfo, userListUserInfo, isModalOpen, emailModalOpen, setModalOpen, buyAllPackagesOrNot, buyPackagesSeparately, paymentIdData, paymentIdFailed, packagesPurchaseTopUpAttempt, packagesPurchaseTopUpError, packagesPurchaseTopUp } = props;

    const idAndTopUpAmount = useLocation();

    const { propertyIndividualId, AmountTopUp } = idAndTopUpAmount.state as NavParams;

    const [focused, setFocused] = useState('manual');
    const [paymentType, setPaymentType] = useState(PaymentTypeEnum.ManualBankTransfer);
    const [viewPrice, setViewPrice] = useState(true);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [fullName, setFullName] = useState(firstName + lastName);
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [bankName, setBankName] = useState('');

    const [breadCrumb, setBreadCrumb] = useState(
        [
            {
                label: Translate.t('GeneralUI.BreadcrumblabelDashboard'),
                onClick: () => { NavActions.navToHome(); },
            },
            {
                label: 'Wallet Top Up',
            },
        ],
    );

    useEffect(() => {
        if (userListUserInfo) {
            setFirstName(userListUserInfo?.firstName ?? '');
            setLastName(userListUserInfo?.lastName ?? '');
            setBankAccountNumber(userListUserInfo.financialInfo?.bankAccNo || '');
            setBankName(userListUserInfo.financialInfo?.bankName || '');
        }
    }, [userListUserInfo?.firstName, userListUserInfo?.lastName, userListUserInfo?.financialInfo?.bankAccNo, userListUserInfo?.financialInfo?.bankType, userListUserInfo?.financialInfo?.bankName]);

    useEffect(() => {
        if ((PaymentTypeEnum.PaymentGateway) && packagesPurchaseTopUp && packagesPurchaseTopUp.url && packagesPurchaseTopUp.url.length) {
            // This will open the stripe payment screen on current screen
            window.open(packagesPurchaseTopUp.url, '_self');
        }
    }, [packagesPurchaseTopUp]);

    const onBackPressedBreadCrumb = () => {
        NavActions.navBack();
    };

    const disableButton = () => {
        if (packagesPurchaseTopUpError.length) {
            return true;
        }
        return false;
    };

    const setPackagesPayment = (PaymentType: number) => {
        if (PaymentType === PaymentTypeEnum.ManualBankTransfer) {
            setPackagesTopUpPayments(propertyIndividualId, PaymentTypeEnum.ManualBankTransfer, AmountTopUp, bankAccountNumber, fullName, bankName, 'Manual Bank Transfer');
        } else {
            setPackagesTopUpPayments(propertyIndividualId, PaymentTypeEnum.PaymentGateway, AmountTopUp, bankAccountNumber, fullName, bankName, 'Payment Gateway');
        }
    };

    const renderTotalPrice = () => {
        if (paymentType === PaymentTypeEnum.PaymentGateway) {
            return (
                <div>
                    {AmountTopUp}
                </div>
            );
        }

        return (
            <div>
                {AmountTopUp}
            </div>
        );
    };

    const renderPaymentBodyInfo = () => {
        if (packagesPurchaseTopUpError.length) {
            return (
                <FailedPaymentMethodContainer>
                    Please try Again
                </FailedPaymentMethodContainer>
            );
        }

        return true;
    };

    return (
        <MainContainer>
            <MainContainerSub>
                <MainContainerBank>
                    <MainTitleContainer>{Translate.t('Packages.PackagesCard.PackagesPaymentOptions')}</MainTitleContainer>
                    <MainCardTypeContainer>
                        <MainCardManualContainerResponsiveManualTransfer onClick={() => [setPaymentType(PaymentTypeEnum.ManualBankTransfer), setFocused('manual')]} focused={focused}>
                            <CardCircleContainer>
                                <ManualTransferType src={Icons.ManualTransfer} />
                            </CardCircleContainer>
                            <TextManualTransfer>{Translate.t('Packages.PackagesCard.BankTransfer')}</TextManualTransfer>

                        </MainCardManualContainerResponsiveManualTransfer>

                        {/* <MainCardManualContainerResponsiveWalletTransfer onClick={() => [setPaymentType(PaymentTypeEnum.PaymentGateway), setFocused('wallet')]} focused={focused}>
                            <CardCircleContainer>
                                <ManualTransferType src={Icons.creditCard} />
                            </CardCircleContainer>
                            <TextWalletTransfer>

                                {Translate.t('Packages.PackagesCard.CardTransfer')}
                            </TextWalletTransfer>
                        </MainCardManualContainerResponsiveWalletTransfer> */}

                    </MainCardTypeContainer>
                    {paymentType === PaymentTypeEnum.ManualBankTransfer ? (
                        <>
                            <BankTransferInfoTitle>{Translate.t('Packages.PackagesCard.BankTransferTitle')}</BankTransferInfoTitle>
                            <BankTransferInfoBody>
                                <p>{Translate.t('Packages.PackagesCard.BodySubTitle')}</p>
                                <MoreDetails>
                                    <BankDetailContainer>
                                        <BankDetailText>{Translate.t('Packages.PackagesCard.BankName')}</BankDetailText>
                                        <BankDesciptionText>{config.dormeoBankDetails.bankName}</BankDesciptionText>
                                    </BankDetailContainer>
                                    <BankDetailContainer>
                                        <BankDetailText>{Translate.t('Packages.PackagesCard.BankNumber')}</BankDetailText>
                                        <BankDesciptionText>{config.dormeoBankDetails.bankNumber}</BankDesciptionText>
                                    </BankDetailContainer>
                                    <BankDetailContainer>
                                        <BankDetailText>{Translate.t('Packages.PackagesCard.AccountName')}</BankDetailText>
                                        <BankDesciptionText>{config.dormeoBankDetails.accountName}</BankDesciptionText>
                                    </BankDetailContainer>
                                </MoreDetails>
                                <WarningSignContainer>{Translate.t('Packages.PackagesCard.PackagesTitleMessage')}</WarningSignContainer>
                            </BankTransferInfoBody>
                        </>

                    ) : (
                        <>
                            {renderPaymentBodyInfo()}
                        </>
                    )}

                </MainContainerBank>
                <PricingCountContainer>
                    <SummaryContainer>
                        <SummaryMainContainer>
                            <CheckOutSummaryContainer>{Translate.t('Packages.PackagesCard.CheckoutSummary')}</CheckOutSummaryContainer>
                        </SummaryMainContainer>

                        <DropdownContentHeaderContentListMainContainer>
                            <DropdownContentHeaderContentList>

                                <DropdownContentHeaderContentItemContainer>
                                    <div>
                                        {!AmountTopUp
                                            ? (
                                                <PackageLoadingContainer>
                                                    Top Up Amount
                                                    <TailSpin color={Colors.primary} height={30} width={30} />
                                                </PackageLoadingContainer>
                                            )
                                            : (
                                                <PackageChoosedContainer>
                                                    Top Up Amount
                                                    <p>
                                                        {Translate.t('Packages.MYR')}
                                                        {' '}
                                                        {AmountTopUp}
                                                    </p>
                                                </PackageChoosedContainer>
                                            )}
                                    </div>
                                </DropdownContentHeaderContentItemContainer>

                                {viewPrice && (
                                    <ViewPriceContainer>
                                        <TotalPriceText>Total:</TotalPriceText>
                                        {Translate.t('Packages.MYR')}
                                        {renderTotalPrice()}
                                    </ViewPriceContainer>
                                )}
                                {!viewPrice && (
                                    <ViewPriceContainer>0</ViewPriceContainer>

                                )}
                            </DropdownContentHeaderContentList>
                        </DropdownContentHeaderContentListMainContainer>
                    </SummaryContainer>
                </PricingCountContainer>

            </MainContainerSub>
            <MainContainerRight>
                {paymentType === PaymentTypeEnum.PaymentGateway ? (
                    <SubscribeButtonCardContainer onClick={() => setPackagesPayment(PaymentTypeEnum.PaymentGateway)} disabled={disableButton()}>
                        {packagesPurchaseTopUpAttempt ? (
                            <TailSpin color={Colors.white} height={20} width={20} />
                        )
                            : (<p>{Translate.t('Packages.PackagesCard.ProceedPayment')}</p>
                            )}
                    </SubscribeButtonCardContainer>

                ) : (
                    <SubscribeButtonContainer onClick={() => setPackagesPayment(PaymentTypeEnum.ManualBankTransfer)}>
                        {packagesPurchaseTopUpAttempt ? (<TailSpin color={Colors.white} height={30} width={30} />) : (
                            <p>{Translate.t('Packages.PackagesCard.ProceedPayment')}</p>
                        )}
                    </SubscribeButtonContainer>
                )}
                {isModalOpen && (
                    <PaymentUpload />
                )}
                <div>
                    {emailModalOpen && (
                        <PackagesEmailPromptModal />
                    )}
                </div>

            </MainContainerRight>
        </MainContainer>
    );
};

const ManualTransferType = styled(SVG)`
    color: #FFCFA6;
    height: 40px;
    width: 40px;
`;

const DropdownContentHeaderContentList = styled.ul`
    list-style: none;
    width: 100%;
    margin: 0 0 4px 0;
    padding: 0;

    > li:not(:first-child){
        padding-top: 8px;
    }

`;

const DropdownContentHeaderContentListMainContainer = styled.ul`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const DropdownContentHeaderContentItemContainer = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 12px;
    margin-bottom: 20px;
    cursor: pointer;
    padding-bottom: 34px;
    &:not(:last-of-type) {
        border-bottom: 0.5px solid grey;
    }
    &:last-of-type {
    padding-bottom: 4px;
    }
`;

const TotalPriceText = styled.p`
    display: flex;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    margin-right: 12px;
    color: #696969;
`;

const ViewPriceContainer = styled.div`
    display: flex;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    gap: 5px;
`;

const PackageChoosedContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
`;

const PackageLoadingContainer = styled.div`
    display: flex;
    padding-right: 10px;
    justify-content: space-between;
    margin-bottom: 20px;
`;

const BankDetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 100%;
    max-height: 60px;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-top: 28px;
    border-bottom: 0.5px solid #B3B3B3;
`;

const BankDetailText = styled.p`
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
`;

const CheckOutSummaryContainer = styled.p`
    display: flex;
    width: 100%;
    line-height: 22px;
    font-weight: 700;
    font-size: 18px;
    align-items: flex-end;

    @media (max-width: 600px) {
        padding-top: 20px;
        line-height: 18px;
        font-weight: 700;
        font-size: 14px;
    }
`;

const SummaryMainContainer = styled.div`
    display: flex;
    width: 60%;
    height: 32px;
    margin-bottom: 25px;
`;

const BankDesciptionText = styled.p`
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    color: #696969;
`;

const WarningSignContainer = styled.div`
    display: flex;
    max-width: 100%;
    max-height: 14px;
    font-weight: 700;
    font-size: 10px;
    line-height: 14px;
    justify-content: center;
`;

const SummaryContainer = styled.div`
    width: 80%;
    height: 73vh;
    background-color: #ffffff;
    margin-bottom: 16%;
    box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 4.65% 20px 4.56% 20px;

    ${media.sm`
        width: unset;
        height: fit-content;
        margin: 20px;
        margin-bottom: 0;
    `}
`;

const PricingCountContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    margin-top: 8.5%;

    ${media.sm`
        margin-top: 0;
    `}
`;

const SubscribeButtonCardContainer = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
        background-color: #FFCFA6;
        cursor: pointer;
    };
    width: 350px;
    border: #ffffff;
    height: 32px;
    background-color: #F2B47E;
    color: #ffffff;
    margin-bottom: 10%;
    box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    padding: 8px;

    ${media.sm`
        width: fit-content;
        margin-top: 40px;
    `}
`;

const SubscribeButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
        background-color: #FFCFA6;
        cursor: pointer;
    };
    width: 40%;
    height: 32px;
    background-color: #F2B47E;
    color: #ffffff;
    margin-bottom: 10%;
    box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    padding: 8px;

    ${media.sm`
        width: fit-content;
        margin-top: 40px;
    `}
`;

const MainTitleContainer = styled.div`
    display: flex;
    width: 313px;
    height: 28px;
    max-width: 313px;
    max-height: 28px;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: black;
    margin-top: 20px;
    margin-bottom: 48px;

    ${media.sm`
        font-size: 18px;
        margin-bottom: 30px;
    `}
`;

const MainCardTypeContainer = styled.div`
    display: flex;
    margin-bottom: 60px;

    ${media.sm`
        margin-bottom: 20px;
    `}
`;

const MainCardManualContainerResponsiveManualTransfer = styled.div<{ focused?: string }>`
    width: 48.5%;
    height: 19.85%;
    background-color: #F2B47E;
    border-radius: 12px;
    margin-right: 16px;
    margin-bottom: 20px;
    color: #fafafa;
    padding-bottom: 20px;
    &:hover {
            cursor: pointer;
            background-color: #FFCFA6;
        }

        ${props => (props.focused === 'manual') && css`
        background-color: #F2B47E;
    `}

    ${props => (props.focused === 'wallet') && css`
        background-color: white;
        border: 1px solid #F2B47E;
        color: black;
    `}

`;

const MainCardManualContainerResponsiveWalletTransfer = styled.div<{ focused?: string }>`
    width: 48.5%;
    height: 19.85%;
    background-color: #F2B47E;
    border-radius: 12px;
    margin-bottom: 20px;
    color: #fafafa;
    padding-bottom: 20px;
    &:hover {
            cursor: pointer;
            background-color: #FFCFA6;
        }

        ${props => (props.focused === 'manual') && css`
        background-color: white;
        border: 1px solid #F2B47E;
        color: black;
    `}

    ${props => (props.focused === 'wallet') && css`
    background-color: #F2B47E;
    `}
`;

const CardCircleContainer = styled.div`
    width: 40px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 32px;
    margin-top: 20px;
    margin-left: 43%;
    margin-bottom: 12px;
`;

const MainContainerBank = styled.div`
    margin: 20px;
    width: 100%;
    margin-bottom: 25px;

    ${media.sm`
        width: unset;
    `}
`;

const MainContainerSub = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-around;
    position: relative;

    ${media.sm`
        flex-direction: column;
    `}
`;

const MainContainerRight = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    margin-top: 3%;
    align-self: center;
    justify-content: center;
`;

const TextManualTransfer = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 16px;
`;

const TextWalletTransfer = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 16px;

`;

const BankTransferInfoTitle = styled.div`
    width: 100%;
    height: 5%;
    padding: 8px;
    margin-bottom: 0px;
    padding-left: 20px;
    color: #ffffff;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    background-color: #F2B47E;
    border-top: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
`;

const FailedPaymentMethodContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20%; 
    box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    color: red;
`;

const MoreDetails = styled.div`
    margin-bottom: 8px;
`;

const BankTransferInfoBody = styled.div`
    width: 100%;
    height: 45%;
    padding: 20px;
    color: #000000;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
`;

const mapStateToProps = (state: RootState) => ({
    loadingPricingAttempt: Selectors.getPackagesGetPackagesPricingAttempt(state),
    errorPricingFailure: Selectors.getPackagesGetPackagesPricingFailure(state),
    packagesPricingList: Selectors.getPackagesGetPackagesPricing(state),
    isModalOpen: Selectors.packagesSetTopUpPaymentModal(state),
    loadingUserInfo: Selectors.getUserGetUserInfoAttempt(state),
    errorUserInfo: Selectors.getUserGetUserInfoFailure(state),
    userListUserInfo: Selectors.getUserGetUserInfo(state),
    buyAllPackagesOrNot: Selectors.packagesSetPackagesBuyAll(state),
    buyPackagesSeparately: Selectors.packagesSetAllPackageCancel(state),
    emailModalOpen: Selectors.packagesSetPackagesEmailModal(state),

    packagesPurchaseTopUpAttempt: Selectors.packagesGetPackagesSetTopUpPaymentsAttempting(state),
    packagesPurchaseTopUpError: Selectors.packagessetPackagesPaymentsError(state),
    packagesPurchaseTopUp: Selectors.packagesGetPackagesSetTopUpPayments(state),
    paymentIdData: Selectors.packagessetPackagesPayments(state),
    paymentIdFailed: Selectors.packagesUploadPackagesDocumentError(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getUserInfo: () =>
        dispatch(Actions.userGetUserInfoAttempt()),
    setModalOpen: (state: boolean) => dispatch(Actions.setPaymentDocumentModalOpen(state)),
    setPackagesTopUpPayments: (propertyId: string, paymentType: number, amount: number, bankNumber: string, accountName: string, bankName: string, reference: string) =>
        dispatch(Actions.packagesSetTopUpPaymentAttempt({ propertyId, paymentType, amount, bankNumber, accountName, bankName, reference })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PackagesWalletTopUp);
